import { GetDoc } from "@/Utils/StateLib";
import { isNullish } from "@theorgchartdev/storybook";
import {
  kBoxStyleRule,
  kFieldOverlayRule,
  kBoxOverlayRule,
  kBranchStyleOverlayRule,
  kMasterPageRule,
  kInheritedRule,
  kHighlightingRule,
  kGroupingRule,
  kPositionBoxStyleRule,
  kPositionFieldOverlayRule,
  kPositionBoxOverlayRule
} from "@coreapp/constants";

const defaultValues = {
  [kFieldOverlayRule]: {
    fFieldName: "",
    fTextColorEnabled: false,
    fCellColorEnabled: false,
    fTextStyleEnabled: false,
    fCellShown: true
  },
  [kBoxOverlayRule]: {
    fShapeEnabled: false,
    fFillEnabled: false,
    fBorderEnabled: false,
    fBorderColorEnabled: false,
    fTriFlagEnabled: false,
    fLineColorEnabled: false,
    fLineDashEnabled: false
  }
};
defaultValues[kPositionFieldOverlayRule] = defaultValues[kFieldOverlayRule];
defaultValues[kPositionBoxOverlayRule] = defaultValues[kBoxOverlayRule];

export const RuleCriteriaTypeMapping = {
  Always: "Always Apply",
  Basic: "Basic Rule",
  Complex: "Complex Rule"
};

export const nameCodeMapping = {
  [kBoxStyleRule]: "Box Style",
  [kPositionBoxStyleRule]: "Box Style",
  [kFieldOverlayRule]: "Field Properties",
  [kPositionFieldOverlayRule]: "Field Properties",
  [kBoxOverlayRule]: "Box Properties",
  [kPositionBoxOverlayRule]: "Box Properties",
  [kBranchStyleOverlayRule]: "Branch Style",
  [kMasterPageRule]: "Master Page",
  [kInheritedRule]: "Link Template",
  [kHighlightingRule]: "Highlight",
  [kGroupingRule]: "Grouping"
};

export const GetStartingSection = rule => {
  const doc = GetDoc();
  const isPositions = doc?.IsPositionDocument() ?? false;

  let defaultSection = kBoxStyleRule;
  if (isPositions) {
    defaultSection = kPositionBoxStyleRule;
  }

  const actionSet = rule?.fActionSet;
  if (!actionSet || Object.keys(actionSet).length === 0) {
    return defaultSection;
  }

  const matchingTab = Object.keys(actionSet).find(anActionKey => nameCodeMapping[anActionKey]);

  return matchingTab ?? defaultSection;
};

export const isModifiedSection = (sectionMapping, rule) => {
  const sectionDefaults = defaultValues[sectionMapping];
  const sectionProperties = Object.entries(rule.fActionSet?.[sectionMapping] || {});

  if (sectionDefaults) {
    // Verify that if there are assigned properties, check are the default value
    return sectionProperties.some(([key, value]) => {
      const defaultValue = sectionDefaults[key];
      if (isNullish(defaultValue)) {
        return false;
      }

      return value !== defaultValue;
    });
  }

  return sectionProperties.length > 0;
};
